<template>
  <div>
    <div v-if="loading" class="vx-row">
      <div class="vx-col w-full mb-base">
        Loading ...
      </div>
    </div>
    <div v-else-if="activeConsultationInfo" class="vx-row">
      <div class="vx-col md:w-1/3 w-full mb-base">
        <vx-card title="" class="pb-4 text-center">
          <h4>
            {{`${activeConsultationInfo.patient.first_name} ${activeConsultationInfo.patient.last_name}`}}
          </h4>
          <p class="mt-2">Paciente ID {{activeConsultationInfo.patient.id}} </p>
          <vs-avatar class="mx-auto mb-6 mt-3 block" size="80px" src='/img/evoUser.6d7a9256.png' />
          <div class="vx-row mb-3 mt-4">
            <div class="vx-col md:w-1/3 w-full">
              <div class="vx-row flex flex-row justify-center">
                <h3>
                  {{
                    activeConsultationInfo.patient.gender ?
                      activeConsultationInfo.patient.gender.toUpperCase().substring(0,1) :
                      'N/A'
                  }}
                </h3>
              </div>  
              <div class="vx-row  flex flex-row justify-center">
                <p>Sexo</p>
              </div>  
            </div>
            <div class="vx-col md:w-1/3 w-full">
              <div class="vx-row flex flex-row justify-center">
                <h3> {{activeConsultationInfo.patient.dob ? calculateAge(activeConsultationInfo.patient.dob) : 'N/A'}} </h3>
              </div>  
              <div class="vx-row  flex flex-row justify-center">
                <p>Años</p>
              </div>  
            </div>
            <div class="vx-col md:w-1/3 w-full">
              <div class="vx-row flex flex-row justify-center">
                <h3>{{ this.allPatientEvents.length }}</h3>
              </div>  
              <div class="vx-row  flex flex-row justify-center">
                <p>Consultas</p>
              </div>  
            </div>
          </div>
          <div class="vx-row mb-3 mt-6">
            <vs-tabs alignment="center" >
              <vs-tab label="Expediente"  icon-pack="feather" icon="icon-clock">
                <!-- ACTIVITY TIMELINE -->
                <div class="vx-col mt-6 w-full mb-base text-left" style=" height: 13.3em; overflow-y: auto; ">
                        <vx-timeline :data="timelineData"></vx-timeline>
                </div>
                        <vs-button  class=" mt-4 w-full" color="primary" type="filled"
                          @click="openPatientView()"
                        >
                          Ver Expediente Completo
                        </vs-button>
              </vs-tab>
              <vs-tab label="Registros" icon-pack="feather" icon="icon-folder">
                <vs-list class="mt-4">
                    <vs-list-header title="Recetas"></vs-list-header>

                    <vs-list-item v-for="item in prescriptionsList" :key="item.prescription_id" :title="'Receta #' + (item.prescription_id)" :subtitle="'Fecha:' + item.date">
                      <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-eye"
                      @click="openRecipeView(item.prescription_id)"
                      ></vs-button>
                    </vs-list-item>


                    <vs-list-header class="mt-4" title="Exámenes"></vs-list-header>

                    <vs-list-item v-for="item in examsList" :key="item.exam_id" :title="'Examen #' + (item.exam_id)" :subtitle="'Fecha:' + item.date">
                      <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-eye"
                      @click="openExamView(item.exam_id)"
                      ></vs-button>
                    </vs-list-item>

                    
                  </vs-list>
                  
                  <vs-button  class=" mt-4 w-full" color="primary" type="filled"
                    @click="openPatientView()"
                  >Ver Expediente Completo</vs-button>

              </vs-tab>
              <vs-tab label="Estadísticas" icon-pack="feather" icon="icon-bar-chart-2">
                <div>
                  <!-- <statistics-card-line
                    v-if="temperatureData"
                    icon="ThermometerIcon"
                    :statistic="temperatureData.records | k_formatter"
                    statisticTitle="Temperatura"
                    :chartData="temperatureData.series"
                    type="area"
                    class="mt-2"
                    color="success"
                    /> -->
                    <vx-card title="Nivel de Azúcar" class="my-2">
                      <vue-apex-charts
                        type="line"
                        height="250"
                        :options="analyticsData.bloodSugar.chartOptions"
                        :series="analyticsData.bloodSugar.tempSeries"
                      />
                    </vx-card>
                    <vx-card title="Presión Arterial" class="my-2">
                      <vue-apex-charts
                        type="line"
                        height="250"
                        :options="analyticsData.bloodPressure.chartOptions"
                        :series="analyticsData.bloodPressure.tempSeries"
                      />
                    </vx-card>
                    <vx-card title="Nivel de Oxigeno" class="my-2">
                      <vue-apex-charts
                        type="line"
                        height="250"
                        :options="analyticsData.bloodOx.chartOptions"
                        :series="analyticsData.bloodOx.tempSeries"
                      />
                    </vx-card>
                    <div v-if="openStatsDiv">
                      <vx-card title="Pulso" class="my-2">
                        <vue-apex-charts
                          type="line"
                          height="250"
                          :options="analyticsData.bloodPulse.chartOptions"
                          :series="analyticsData.bloodPulse.tempSeries"
                        />
                      </vx-card>
                    </div>
                </div>
                
                <vs-button  class="mt-6 w-full" color="primary" type="filled"
                  @click="openStatsDiv = !openStatsDiv"
                >{{ !openStatsDiv ? 'Ver Mas': 'Ver Menos'}}</vs-button>
              </vs-tab>
            </vs-tabs>
          </div>

        </vx-card>
      </div>
      <!-- form wizard Container -->
      <div class="vx-col md:w-2/3 w-full mb-base">
        <vx-card :title="'Consulta '+activeConsultationInfo.id">
            <div class="vx-row w-full ">
              <div class="vx-col mt-5 w-full flex flex-wrap" style="justify-content: space-between;">
                <p class="inline mt-3">Fecha y Hora de Inicio:
                  <code class="text-primary">
                    {{new Date(activeConsultationInfo.date).toLocaleDateString('es-ES', dateStringOptions)}}
                    -
                    {{new Date(activeConsultationInfo.date).toLocaleTimeString('en-EN', timeStringOptions)}}
                  </code>
                </p>
                <div class="ml-3"
                  v-if="
                    activeConsultationInfo.clinic.meta && activeConsultationInfo.clinic.meta.type && 
                    activeConsultationInfo.clinic.meta.type.toLowerCase() == 'virtual'"
                >
                  <img class="zoom" @click="goZM" src="https://img.icons8.com/color/40/000000/zoom.png"/>
                </div>
                <div class="flex mt-4" v-if="!isSecretary">
                  <vs-button v-if="activeConsultationInfo.meta && activeConsultationInfo.meta.status && activeConsultationInfo.meta.status == 'Terminada'"
                    class="ml-2" color="warning" type="filled" icon-pack="feather" :icon="!isReadOnly ? 'icon-eye': 'icon-edit'" 
                    @click="editConsultation">{{ !isReadOnly ? 'Solo Lectura': 'Editar'}}
                  </vs-button>
                  <vs-button v-if="activeUserInfo.role == 'doctor'" class="mx-3 " color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="showCancelConsultationModal">
                    Anular
                  </vs-button>
                </div>
                <div class="flex mt-4" v-else>
                  <code>Modo Lectura</code>
                </div>
                
              </div>
            </div>

            <div class="mt-5">
                <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" >
                    <!-- Informacion -->
                    <tab-content title="Información" class="mb-5" icon="feather icon-info">

                        <!-- tab 1 content -->
                        <div class="vx-row">
                            <div class="vx-col w-full mt-5">
                              <div class="vx-row">
                                <h6 class="mb-2">Motivo de Consulta</h6>
                              </div>
                              <div class="vx-row mt-3">
                                <vs-textarea v-bind:readonly="isReadOnly" v-model="consultationDetail.comments_obs" />
                              </div>
                            </div>
                            <!-- <div class="vx-col md:w-1/2 w-full mt-5 pr-5">
                              
                              <div class="vx-row">
                                <div class="vx-col w-full">
                                  <h6 class="mb-2">Enfermedades</h6>
                                </div>
                                <div class="mt-3 w-full">
                                  <vs-textarea v-model="consultationDetail.diseases" />
                                </div>
                                  
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5 pr-5">
                              
                              <div class="vx-row">
                                <div class="vx-col w-full">
                                  <h6 class="mb-2 ml-4">Medicamentos que utiliza</h6>
                                </div>
                                <div class="vx-col w-full mt-3 pl-6">
                                  <vs-textarea v-model="consultationDetail.usedMeds" />
                                </div>
                              </div>                      
                            </div> -->

                            <div class="vx-col w-full mt-5">
                              <vs-collapse type="margin">
                                <vs-collapse-item>
                                  <div slot="header">
                                    Síntomas COVID
                                  </div>
                                  <div class="vx-row">

                                    <div class="vx-col md:w-1/3 w-full pl-6 pb-3">
                                      <div class="vx-row ml-3">
                                        <small class="mb-2 " >Fiebre</small>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.fever">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <small class="mt-3 mb-2">Tos Seca</small>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.dryCough">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                    </div> 

                                    <div class="vx-col md:w-1/3 w-full pl-6 pb-3">
                                      <div class="vx-row ml-3">
                                        <small class="mb-2 " >Cansancio</small>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.tiredness">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <small class="mt-3 mb-2">Dolor de Garganta</small>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.throatPain">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                    </div> 


                                    <div class="vx-col md:w-1/3 w-full pl-6 pb-3">
                                      <div class="vx-row ml-3">
                                        <small class="mb-2 " >Diarrea</small>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.diarrhea">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <small class="mt-3 mb-2">Dolor de Cabeza</small>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.headache">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                    </div> 

                                    <div class="vx-col md:w-1/3 w-full pl-6 pb-3">
                                      <div class="vx-row ml-3">
                                        <small class="mb-2 " >Perdida del sentido del olfato o del gusto</small>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.smellTasteLoss">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <small class="mt-3 mb-2">Dificultad para respirar</small>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.breathingDifficulty">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                    </div> 

                                    <!-- <div class="vx-col md:w-1/3 w-full pl-6 pb-3">
                                      <div class="vx-row ml-3">
                                        <small class="mb-2 " >Presión alta</small>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.pressure">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <small class="mt-3 mb-2">Fiebre</small>
                                      </div>
                                      <div class="vx-row ml-3">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.fever">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                    </div> -->

                                    <!-- <div class="vx-col md:w-1/3 w-full pl-6">
                                      <div class="vx-row">
                                        <small class="mb-2" >Nausea</small>
                                      </div>
                                      <div class="vx-row">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.nausea">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                      <div class="vx-row">
                                        <small class="mt-3 mb-2">Cansancio</small>
                                      </div>
                                      <div class="vx-row">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.tiredness">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                    </div> -->
                                    <!-- <div class="vx-col md:w-1/3 w-full">
                                      <div class="vx-row">
                                        <small class="mb-2" >Fatiga</small>
                                      </div>
                                      <div class="vx-row">
                                        <vs-switch color="success" v-bind:disabled="isReadOnly" v-model="consultationDetail.main_symptoms.fatigue">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                    </div> -->
                                    
                                  </div>
                                </vs-collapse-item>
                                
                                <!-- <vs-collapse-item>
                                  <div slot="header">
                                    Evacuaciones
                                  </div>
                                  <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full pl-6 pb-3">
                                      <small class="mb-2" >¿Cada Cuánto?</small>
                                    </div>
                                    <div class="vx-col md:w-2/3 w-full pl-6 pb-3">
                                        <v-select class="w-full" :options="freqOps" taggable push-tags :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                    </div>
                                  </div>
                                  <div class="vx-row">
                                    <div class="vx-col md:w-1/3 w-full pl-6 pb-3">
                                      <small class="mb-2" >¿Color?</small>
                                    </div>
                                    <div class="vx-col md:w-2/3 w-full pl-6 pb-3">
                                        <v-select class="w-full" :options="colors" taggable push-tags :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                    </div>
                                  </div>
                                  <div class="vx-row">

                                    <div class="vx-col md:w-1/3 w-full pl-6 pb-3">
                                      <div class="vx-row">
                                        <small class="mb-2" >Son Normales</small>
                                      </div>
                                      <div class="vx-row">
                                        <vs-switch color="success" v-model="switch7">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                      <div class="vx-row">
                                        <small class="mt-3 mb-2">Diarrea</small>
                                      </div>
                                      <div class="vx-row">
                                        <vs-switch color="success" v-model="switch8">
                                            <span slot="on">Si</span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                      </div>
                                    </div>
                                  </div>
                                </vs-collapse-item> -->

                              </vs-collapse>
                              <vs-divider></vs-divider>
                              <vs-row vs-w="12">
                                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="6">
                                  <h5>Preguntas Personalizadas</h5>
                                </vs-col>
                              </vs-row>
                              <vs-row vs-w="12" v-for="(question, key) in userQuestions" :key="key" class="mt-2" >
                                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="12" v-if="question.active">
                                  <div class="vx-col w-full">
                                    <p>{{question.title}}</p>
                                    <vs-textarea v-bind:readonly="isReadOnly" v-model="customQuestionsAnswers[key]" :label="question.placeholder" class="mb-3" rows="1" />
                                  </div>
                                </vs-col>
                              </vs-row>
                              <vs-divider></vs-divider>
                              <div class="vx-row">
                                <div class="vx-col w-full">
                                  <p>Notas adicionales</p>
                                  <vs-textarea v-bind:readonly="isReadOnly" v-model="consultationDetail.importantNotes" label="Notas Importantes" class="mb-0 md:mt-5 mt-3" rows="2" />
                                </div>
                              </div>
                            </div>
                        </div>

                    </tab-content>

                    <!-- Examen médico -->
                    <tab-content title="Examen médico" class="mb-5" icon="feather icon-edit">
                        <div class="vx-row">
                            <div class="vx-col w-full mt-5">
                              <div class="vx-row">
                                <h3 class="mb-2">Exámen Físico</h3>
                              </div>
                              <div class="vx-row mt-4 pl-4">
                                <vs-textarea v-bind:readonly="isReadOnly" rows="4" v-model="consultationDetail.physical_exam" />
                              </div>

                            </div>
                            <vs-divider class="mt-6"></vs-divider>
                            <div class="vx-col w-full mt-3 pl-6">
                              <div class="vx-row">
                                <h4 class="mb-2">Signos Vitales</h4>
                              </div>
                              <div class="vx-row">
                                <h5 class="mb-2">Seleccione los signos vitales que desee agregar</h5>
                              </div>
                              <div class="vx-row">
                                <div class="vx-col w-full mt-3 pl-6">
                                  <multiselect
                                    v-bind:disabled="isReadOnly"
                                    v-model="consultationDetail.vitalSigns"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="Elegir Signos a medir"
                                    :multiple="true"
                                    label="name"
                                    track-by="name"
                                    :options="vitalSignsList"
                                    style="z-index: 1000;" >
                                  </multiselect>
                                </div>
                              </div>
                              <!-- VITAL SIGNS DISPLAY -->
                              <div v-for="(element,i) in consultationDetail.vitalSigns" :key="i" >
                                <div class="vx-row mt-5">
                                  <div class="vx-col flex  w-full mt-2 pl-3">
                                    <h5 class="mt-2">{{element.name}}</h5>
                                     <vs-button class="inline ml-3" color="danger" type="flat" icon-pack="feather" 
                                      icon="icon-trash"
                                      @click="removeVitalSign(i)"
                                    ></vs-button>
                                  </div>
                                </div>
                                <div v-if="element.options">
                                  <div class="vx-row mb-3"  v-for="(option,e) in element.options" :key="e">
                                    <div class="vx-col w-full flex ">
                                      <p>{{option.name}}</p>
                                    </div>
                                    <div class="vx-col w-3/5 pl-6 items-center ">
                                        <vs-input v-bind:readonly="isReadOnly" v-if="element.id == 1" class="w-full" icon-after vs-icon-after="true"
                                          :placeholder="option.name" v-model="option.value" 
                                        >
                                        </vs-input>
                                        <vs-select v-if="element.id == 2 && option.id == 1"
                                          v-bind:disabled="isReadOnly"
                                          class="w-full"
                                          v-model="option.value"
                                          :placeholder="option.name"
                                        >
                                          <vs-select-item :key="idx" :value="item" :text="item" v-for="(item,idx) in option.options" />
                                        </vs-select>
                                        <div v-if="element.id == 2 && option.id == 2" class="flex">
                                          <vs-input v-bind:readonly="isReadOnly" class="w-1/2 mr-2" icon-after vs-icon-after="true"
                                            :placeholder="option.name" v-model="option.value" 
                                          >
                                          </vs-input>
                                          <vs-select
                                            v-bind:disabled="isReadOnly" 
                                            class="w-1/2"
                                            v-model="option.unit"
                                            placeholder="Unidades"
                                          >
                                          <vs-select-item :key="idx" :value="item" :text="item" v-for="(item,idx) in option.units" />
                                          </vs-select>
                                        </div>
                                        <div v-if="element.id == 2 && option.id == 3" class="flex">
                                          <vs-select 
                                            class="w-1/2"
                                            v-model="option.value"
                                            :placeholder="option.name"
                                          >
                                          <vs-select-item :key="idx" :value="item" :text="item" v-for="(item,idx) in option.options" />
                                          </vs-select>
                                        </div>
                                        <div v-if="element.id == 2 && option.id == 4" class="flex">
                                          <vs-input class="w-1/2 mr-2" icon-after vs-icon-after="true"
                                            :placeholder="option.name" v-model="option.value" 
                                          >
                                          </vs-input>
                                        </div>
                                        <!-- NIVEL DE OXIGENO -->
                                        <!-- TIPO DE LECTURA -->
                                        <div v-if="element.id == 3 && option.id == 1" class="flex">
                                          <vs-select 
                                            class="w-1/2"
                                            v-model="option.value"
                                            :placeholder="option.name"
                                          >
                                          <vs-select-item :key="idx" :value="item" :text="item" v-for="(item,idx) in option.options" />
                                          </vs-select>
                                        </div>
                                        <!-- NIVEL DE OXIGENO -->
                                        <div v-if="element.id == 3 && option.id == 2" class="flex">
                                          <vs-input class="w-1/2 mr-2" icon-after vs-icon-after="true"
                                            :placeholder="option.name" v-model="option.value" 
                                          >
                                          </vs-input>
                                          <h4 class="mt-1"> {{option.unit}} </h4>
                                        </div>
                                        <!-- PULSO -->
                                        <!-- LUGAR -->
                                        <div v-if="element.id == 4 && option.id == 1" class="flex">
                                          <vs-select 
                                            class="w-1/2"
                                            v-model="option.value"
                                            :placeholder="option.name"
                                          >
                                          <vs-select-item :key="idx" :value="item" :text="item" v-for="(item,idx) in option.options" />
                                          </vs-select>
                                        </div>
                                        <!-- PULSO -->
                                        <div v-if="element.id == 4 && option.id == 2" class="flex">
                                          <vs-input class="w-1/2 mr-2" icon-after vs-icon-after="true"
                                            :placeholder="option.name" v-model="option.value" 
                                          >
                                          </vs-input>
                                          <h5 class="mt-2"> {{option.unit}} </h5>
                                        </div>
                                        <!-- COLESTEROL -->
                                        <!-- COLESTEROL TOTAL, HDL, LDL, Trigliséridos-->
                                        <div 
                                          v-if="element.id == 5 && 
                                          (option.id == 1 || option.id == 2 || option.id == 3 || option.id == 4  || option.id == 5 )"
                                          class="flex">
                                          <vs-input class="w-1/2 mr-2" icon-after vs-icon-after="true"
                                            :placeholder="option.name" v-model="option.value" 
                                          >
                                          </vs-input>
                                          <h5 class="mt-2"> {{option.unit}} </h5>
                                        </div>
                                        <!-- DOLOR -->
                                        <!-- Ubicacion -->
                                        <div v-if="element.id == 6 && (option.id == 1) " class="flex">
                                          <vs-textarea class="w-1/2 mr-2" icon-after vs-icon-after="true"
                                            :placeholder="option.title" v-model="option.location" 
                                          >
                                          </vs-textarea>
                                        </div>
                                        <!-- Intensidad -->
                                        <div v-if="element.id == 6 && (option.id == 2) " class="flex">
                                          <vs-select 
                                            class="w-1/2"
                                            v-model="option.value"
                                            :placeholder="option.title"
                                          >
                                          <vs-select-item :key="idx" :value="item" :text="item" v-for="(item,idx) in option.options" />
                                          </vs-select>
                                        </div>
                                        <!-- FRECUENCIA RESPIRATORIA -->
                                        <div v-if="element.id == 7 && (option.id == 1) " class="flex">
                                          <vs-input class="w-1/2 mr-2" icon-after vs-icon-after="true"
                                            :placeholder="option.title" v-model="option.location" 
                                          >
                                          </vs-input>
                                          <h5 class="mt-2"> {{option.units}} </h5>
                                        </div>
                                    </div>
                                    <div class="vx-col text-left w-2/5" v-if="element.id == 1">
                                      <span class="" style="font-weight: 500">{{option.units}}</span>
                                    </div>
                                  </div>
                                </div>
                                <vs-divider></vs-divider>
                              </div>
                              <!-- / VITAL SIGNS DISPLAY -->
                              <vs-divider class="mt-6"></vs-divider>
                              <div class="vx-row">
                                <h4 class="mb-2 mt-3">Observaciones del exámen físico</h4>
                              </div>
                              <div class="vx-row mt-4 pl-4">
                                <vs-textarea v-bind:readonly="isReadOnly" label="Comentarios y Observaciones" v-model="consultationDetail.physical_notes" />
                              </div>
                              <div class="vx-row">
                                <h5 class="mb-2 mt-6">Adjuntar Imágen/Documento</h5>
                              </div>
                              <div class="vx-row mt-4 pl-4 flex flex-col justify-center">
                                  <div class="excel-import">
                                    <input type="file" ref="fileInput" class="hidden" multiple accept="image/*, .xls, .pdf, .xlsx" @change="handleClick">
                                    <div
                                      
                                      @click="$refs.fileInput.click()"
                                      @drop="handleDrop"
                                      @dragover="handleDragover"
                                      @dragenter="handleDragover"
                                      class="px-8 py-5 my-4 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl"
                                      
                                      >
                                      <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
                                      <span>Arrastrar o</span>
                                      <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()"> Buscar</span>
                                      <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
                                    </div>
                                  </div>
                              </div>
                              <div class="vx-row">
                                <h5 class="mb-2 mt-6">Archivos Adjuntos</h5>
                              </div>
                              <vs-row vs-type="flex" vs-justify="space-around" >
                                <vs-col v-for="(document, key) in documentsList" :key="key"   vs-type="flex" vs-justify="center" vs-align="center" class="my-2" vs-w="6">
                                  <code class="shadow">
                                    <a :href="document.fileURL" target="_blank"> {{document.fileName}} </a>
                                  </code>
                                </vs-col>
                              </vs-row>
                            </div>
                        </div>
                        
                    </tab-content>

                    <!-- Diagnósitco -->

                  <modal
                    name="addEnfModal"
                    height="auto"
                    width="60%"
                    :draggable="true"
                    :scrollable="true"
                    style="z-index: 1001;"
                  >
                    <div class="py-5 px-3">
                      <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                              <h3>Agregar Enfermedad</h3>
                            </div>
                      </div>
                      <div class="vx-row">
                            <div class="vx-col w-full">
                              <vs-table search stripe max-items="10" pagination :data="cieArray">
                                <template slot="thead">
                                  <vs-th sort-key="idx">No.</vs-th>
                                  <vs-th sort-key="c">Código</vs-th>
                                  <vs-th sort-key="d">Descripción</vs-th>
                                </template>
                                <template slot-scope="{data}">
                                <vs-tr :key="idx" v-for="(tr,idx) in data">

                                  <vs-td :data="idx">
                                    {{ idx }}
                                  </vs-td>

                                  <vs-td :data="data[idx].c">
                                    {{ data[idx].c }}
                                  </vs-td>

                                  <vs-td :data="data[idx].d">
                                    {{ data[idx].d }}
                                  </vs-td>

                                </vs-tr>
                              </template>
                              </vs-table>
                            </div>
                      </div>
                    </div>

                  </modal>
                  <modal
                    name="addMedModal"
                    height="auto"
                    :draggable="true"
                    :resizable="true"
                  >
                    <div class="py-5 px-2">
                      <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                              <h3>Agregar Medicamento</h3>
                            </div>
                      </div>
                    </div>

                  </modal>
                  <!-- cancelConsultationModal -->
                  <modal
                    name="cancelConsultationModal"
                    height="auto"
                    width="50%"
                    style="z-index: 1001;"
                  >
                    <div class="p-4" @click.self="close">
                      <div class="vx-row ">
                        <!-- <div class="mt-3 mb-4 vx-col w-full flex flex-col items-center">
                          <img src="@/assets/images/logo/logo.png" style="width: 70px; height: 70px;" >
                        </div> -->
                        <div class="mb-4 vx-col w-full flex flex-col text-center">
                          <h3>Confirme por favor para poder anular la consulta</h3>
                        </div>
                        <div class="mb-4 mt-5  vx-col w-full flex flex-col items-center">
                          <vs-button  class="w-1/2" color="danger" type="filled" icon="check" @click="cancelConsultation">Anular Consulta</vs-button>
                          <vs-button  class="mt-3 w-1/2" color="success" type="filled" icon="close" @click="closeCancelConsultationModal">Cancelar</vs-button>
                        </div>
                      </div>
                    </div>
                  </modal>
                  <!-- formSubmittedModal -->
                  <modal
                    name="formSubmittedModal"
                    height="auto"
                    width="50%"
                    style="z-index: 1001;"
                  >
                    <div class="p-4">
                      <div class="vx-row ">
                        <div class="mt-3 mb-4 vx-col w-full flex flex-col items-center">
                          <img src="@/assets/images/logo/logo.png" style="width: 70px; height: 70px;" >
                        </div>
                        <div class="mb-4 vx-col w-full flex flex-col text-center">
                          <h3>Consulta Guardada Éxitosamente</h3>
                        </div>
                        <div class="mb-4 mt-5  vx-col w-full flex flex-col items-center">
                          <!--<vs-button  class="w-1/2" color="primary" type="filled" icon="dashboard" @click="goTobox">Ir al Inicio</vs-button> -->
                          <vs-button v-if="this.consultationDetail && this.consultationDetail.status && this.consultationDetail.status !== 'Terminada'" 
                            class="mt-3 w-1/2" color="success" type="filled" icon="check" @click="finishConsultation">Marcar como Terminada</vs-button>
                        </div>
                      </div>
                    </div>
                  </modal>
                  <modal
                    name="recordModal"
                    style="z-index: 1001;"
                    height='auto'
                  >
                    <div class="p-4">
                      <div class="vx-row ">
                        <div class="mt-3 mb-4 vx-col w-full flex flex-col items-center">
                          <h2>{{timelineRecord.title}}</h2>
                        </div>
                        <vs-divider position="center" :color="timelineRecord.color"><feather-icon :icon="timelineRecord.icon" svgClasses=" stroke-current w-5 h-5" /></vs-divider>
                        <div class="mt-3 mb-4 vx-col w-full flex flex-col items-center" v-if="timelineRecord.detailedDesc">
                          <template v-if="timelineRecord.detailedDesc.exercise">
                            <h4>Tipo de ejercicio</h4>
                            <h5>{{timelineRecord.detailedDesc.exercise.exerciseType}}</h5><br>
                            <h4>¿Con qué frecuencia?</h4>
                            <h5>{{timelineRecord.detailedDesc.exercise.exerciseFreq}}</h5><br>
                            <h4>Tiempo (min)</h4>
                            <h5>{{timelineRecord.detailedDesc.exercise.exerciseTime}}</h5>
                          </template>
                          <h4 v-else>{{timelineRecord.detailedDesc}}</h4>
                        </div>
                        <div class="mt-3 mb-4 vx-col w-full flex flex-col items-center" v-else>
                          <h4>{{timelineRecord.desc}}</h4>
                        </div>
                        <div class="mt-3 mb-4 vx-col w-full flex flex-col items-center">
                          <p>{{timelineRecord.time}}</p>
                        </div>
                      </div>
                    </div>
                  </modal>
                  <template slot="footer" slot-scope="props">
                          <div class="wizard-footer-left">
                            <vs-button  v-if="props.activeTabIndex > 0" @click="props.prevTab(); scroll()" :style="props.fillButtonStyle">Atras</vs-button>
                          </div>
                          <div class="wizard-footer-right">
                            <vs-button v-if="!props.isLastStep" @click="props.nextTab(); scroll()" class="wizard-footer-right" :style="props.fillButtonStyle">Siguiente</vs-button>
                            <vs-button v-else-if="!isSecretary" @click="formSubmitted()" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{props.isLastStep ? 'Guardar' : 'Siguiente'}}</vs-button>
                            <vs-button v-else @click="goBack(); scroll()" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{props.isLastStep ? 'Regresar' : 'Siguiente'}}</vs-button>
                          </div>
                  </template>
                </form-wizard>
            </div>
        </vx-card>
      </div>
    </div>

  </div>
  
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect                  from 'vue-select'
import VxTimeline               from '@/components/timeline/VxTimeline.vue'
import Multiselect              from 'vue-multiselect'
import StatisticsCardLine       from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData            from '@/views/ui-elements/card/analyticsData.js'
import VueApexCharts            from 'vue-apexcharts'
import moment                   from 'moment'

// firebase
import firebase from 'firebase/app' 
import 'firebase/storage';

// cie10 list
var cie10 = require('cie10');
var cieArray = cie10('array');
var cieObj = cie10('obj');

// // drugs
// var drugs = require('drugs');

// BUS
import { bus } from '@/main'
import ComingSoonVue from '../../pages/ComingSoon.vue'

export default {
  data () {
    return {
      // questions
      userQuestions: [],
      customQuestionsAnswers: [],
      isSecretary: false,
      examsList: [],
      prescriptionsList: [],
      isReadOnly: false,
      currentConsultation: {},
      loading: true,
      paid: false,  
      // documents management
      documentsList: [], 
      // SIGNOS VITALES
      vitalSignsList: [
        {
          id: 1,
          name: 'Presión Arterial',
          options: [
            {
              name: 'Presión Sistólica',
              units: 'mmHg',
              value: null
            },
            {
              name: 'Presión Diastólica',
              units: 'mmHg',
              value: null
            }
          ],
        },
        {
          id: 2,
          name: 'Niveles de Azúcar',
          options: [
            {
              id: 1,
              name: 'Tipo de Lectura',
              options: ['2 horas después de desayuno', 'Antes de almorzar', '2 horas depués de almorzar', 
                'Antes de cenar', '2 horas después de cenar', 'Antes de dormir',
                '3AM', 'Aleatorio', 'Insulina Basal '],
              value: null
            },
            {
              id: 2,
              name: 'Valor',
              units: ['mg/dL', 'mmol/L'],
              value: null,
              unit: null,
            },
            {
              id: 3,
              name: 'Glucómetro o Laboratorio',
              options: ['Glucómetro', 'Laboratorio'],
              value: null
            },
            {
              id: 4,
              name: 'Insulina',
              value: null
            }

          ],
          
        },
        {
          id: 3,
          name: 'Nivel de Oxigeno',
          options: [
            {
              id: 1,
              name: 'Tipo de lectura',
              options: ['Método del oxímetro de pulso', 'Gasometría arterial'],
              value: null
            },
            {
              id: 2,
              name: 'Nivel de Oxigeno',
              unit: '%',
              value: null
            }
          ]
        },
        {
          id: 4,
          name: 'Pulso',
          options: [
            {
              id: 1,
              name: 'Lugar',
              options: ['Cuello', 'Muñeca'],
              value: null
            },
            {
              id: 2,
              name: 'Pulso',
              unit: 'bpm',
              value: null
            },
          ]
        },
        {
          id: 5,
          name: 'Colesterol',
          options: [
             {
              id: 1,
              name: 'Colesterol Total',
              unit: 'mg/dL',
              value: null
            },
            {
              id: 2,
              name: 'HDL',
              unit: 'mg/dL',
              value: null
            },
            {
              id: 3,
              name: 'LDL',
              unit: 'mg/dL',
              value: null
            },
            {
              id: 4,
              name: 'Triglicéridos',
              unit: 'mg/dL',
              value: null
            },
            {
              id: 5,
              name: 'VLDL',
              unit: 'mg/dL',
              value: null
            },
          ], 
        },
        {
          id: 6,
          name: 'Dolor',
          options: [
            {
              id: 1,
              name: 'Ubicación',
              title: 'Ubicación',
              location: null,
            },
            {
              id: 2,
              name: 'Intensidad del dolor',
              title: 'Intensidad del dolor',
              options: ['Sin Dolor', 'Menor - Muy Leve', 'Menor - Incómodo', 'Menor - Tolerable',
              'Moderado - Muy Angustioso', 'Moderado - Muy Agustioso', 'Severo - Muy Intenso',
              'Severo - Totalmente Horrible', 'Severo - Inaguantable ', 'Severo - Inimaginable' ],
              value: null
            }
          ],
          
        },
        {
          id: 7,
          name: 'Frecuencia Respiratoria',
          options: [
            {
              id: 1,
              title: 'Ritmo respiratorio',
              Name: 'Ritmo respiratorio',
              units: 'Respiraciones/min',
              value: null
            }
          ],   
        }
      ],
      prescriptionDetail: {
        instructions: null,
        medications: [],
      },
      hasActiveExam: false,
      hasActivePrescription: false,
      examDetail: {
        exam_instructions: null,
        exams: [],
      },
      prescriptionMeds: null,
      forceRecipeUpdate: 0,
      forceExamUpdate: 0,
      dateStringOptions:  { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      timeStringOptions:  { hour: 'numeric', minute: 'numeric', hour12: true },
      activePromptRecipe: false,
      activePromptExams: false,
      openStatsDiv: false,
      revenueComparisonLine: {},
      analyticsData,
      subscribersGained: {},
      temperatureData: {
        status: 'Normal',
        records: 35.5,
        series: [
          {
            data: [35.7,36.5,35.5,35.4, 35.5, 35.3, 35.4,35.5],
            name: 'Temperatura'
          }
        ]
      },  
      pressureSData: {
        status: 'Normal',
        records: 100,
        series: [
          {
            data: [80, 85, 100, 95, 110, 120, 105, 100],
            name: 'Temperatura'
          }
        ]
      },  
      pressureDData: {
        status: 'Normal',
        records: 10,
        series: [
          {
            data: [70, 75, 77, 80, 82, 83, 82, 80],
            name: 'Temperatura'
          }
        ]
      },  
      consultationDetail: {
        comments_obs: null,
        diseases: [],
        medicaments: [],
        evaluationQuestions: [],
        importantNotes: null,
        physical_exam: null,
        vitalSigns: [],
        vitalSignsArr: [],
        physical_notes: null,
        documents: [],
        cie10: [],
        exams: [],
        meds: [],
        usedMeds: [],
        diagnosis_eval: null,
        nextConsultation: {
          requestNext: false,
          whenQty: null,
          whenFrq: null,
        },
        consultationTotal: null,
        paid: false,
        paymentMethod: null,
        main_symptoms: {
          pressure: false,
          fever: false,
          nausea: false,
          tiredness: false,
          fatigue: false
        }
      },
      consultationDetailDef: {
        comments_obs: null,
        diseases: [],
        medicaments: [],
        evaluationQuestions: [],
        importantNotes: null,
        physical_exam: null,
        vitalSigns: [],
        vitalSignsArr: [],
        physical_notes: null,
        documents: [],
        cie10: [],
        exams: [],
        meds: [],
        usedMeds: [],
        diagnosis_eval: null,
        nextConsultation: {
          requestNext: false,
          whenQty: null,
          whenFrq: null,
        },
        consultationTotal: null,
        paid: false,
        paymentMethod: null,
        main_symptoms: {
          pressure: false,
          fever: false,
          nausea: false,
          tiredness: false,
          fatigue: false
        }
      },
      // CIE-10
      cieArray: null,
      wasSidebarOpen: null,
      popupActive: false,
      popupActive2: false,
      firstName: '',
      lastName: '',
      email: '',
      proposalTitle: '',
      jobTitle: '',
      textarea: '',
      eventName: '',
      status: 'plannning',
      value3: [],
      value2: [],
      value: null,
      value1: [],
      textareas: [],
      selected: null,
      // switches
      patientStatistics: [
        {
          id: 1,
          name: 'Presión Arterial',
          val: 16*2,
          valTxt1: '80-120 mmHg',
          comparedResult: '-1',
          valTxt0: '120-139 mmHg',
          color: 'success'
        },
        {
          id: 2,
          name: 'Saturación Oxigeno',
          val: 16*5,
          valTxt1: '96%',
          comparedResult: '+5',
          valTxt0: '91%',
          color: 'success'
        },
        {
          id: 3,
          name: 'Pulso',
          val: 16*2,
          valTxt1: '80-83 PPM',
          comparedResult: '+1',
          valTxt0: '80-83 PPM',
          color: 'success'
        },
        {
          id: 4,
          name: 'Temperatura',
          val: 16*5,
          valTxt1: '37.5º C',
          comparedResult: '+1',
          valTxt0: '3.5º C',
          color: 'danger'
        }
      ],
      solOptions: [
        {
          name: 'Resonancia Magnetica',
          type: 'Resonancia',
          instructions: null,
        },
        {
          name: 'Tomografía Computarizada',
          type: 'Resonancia',
          instructions: null,
        },
        {
          name: 'Tomografía de Arterias Coronarias',
          type: 'Resonancia',
          instructions: null,
        },
        {
          name: 'Rayos X Digital Alta Resolución',
          type: 'Rayos X',
          instructions: null,
        },
        {
          name: 'Ultrasonido de Alta Resolución',
          type: 'Ultrasonido',
          instructions: null,
        },
        {
          name: 'Mamografía en 3D – Tomosíntesis –',
          type: '3D',
          instructions: null,
        },
        {
          name: 'Mamografía digital',
          type: 'digital',
          instructions: null,
        },
        {
          name: 'Densintometría Ósea',
          type: 'Densintometría',
          instructions: null,
        },
        {
          name: 'Prueba HPV',
          type: 'Prueba',
          instructions: null,
        },
        {
          name: 'ELECTROENCEFALOGRAMA',
          type: 'ELECTROENCEFALOGRAMA',
          instructions: null,
        },
        {
          name: 'ELECTROMIOGRAFÍA',
          type: 'ELECTROMIOGRAFÍA',
          instructions: null,
        },
        {
          name: 'Electrocardiograma',
          type: 'Electrocardiograma',
          instructions: null,
        }
      ],
      currentDrug: null,
      currentExamInst: [],
      currentExam: null,
      timelineData: [
        {
            color: "dark",
            icon: "AlertCircleIcon",
            title: "No hay Registros",
            desc: "Paciente Nuevo",
            // time  : 'Hoy'
          },
      ],
      timelineDataDefault: [
        {
          color : 'warning',
          icon  : 'AlertCircleIcon',
          title : 'No hay Registros',
          desc  : 'Paciente Nuevo',
          // time  : 'Hoy'
        },
      ],
      timelineRecord: {
        title: '',
        desc: '',
        time: ''
      },
      dosisOpt:[
        {text:'Tableta/s',value:0},
        {text:'Capsula/s',value:2},
        {text:'Gota/s',value:3},
        {text:'Supositorio/s',value:4},
        {text:'Inyección/es',value:5},
        {text:'Cucharada/s',value:6},
        {text:'Unidad/es',value:7},
      ],
      freqOpt: [
        {text:'Minuto/s',value:0},
        {text:'Horas/s',value:6},
        {text:'Día/s',value:2},
        {text:'Semana/s',value:3},
        {text:'Mes/es', value: 4},
        {text:'Año/s',value:5},
        {text:'Cuando se necesite',value:6},
      ],
      durOpt: [
        {text:'Día/s',value:0},
        {text:'Semana/s',value:2},
        {text:'Mes/es',value:3},
        {text:'Indefinido',value:4},
      ] 
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    activeConsultationInfo () {
      if(this.$store.state.activeConsultationInfo) {
          this.consultationDetail = {...this.consultationDetail, ...this.$store.state.activeConsultationInfo.meta
        };
        this.isReadOnly = this.consultationDetail && this.consultationDetail.status && this.consultationDetail.status == 'Terminada';
          // console.log(this.consultationDetail)
        this.documentsList =  this.$store.state.activeConsultationInfo.meta && this.$store.state.activeConsultationInfo.meta.documentsList ?
         JSON.parse(JSON.stringify(this.$store.state.activeConsultationInfo.meta.documentsList)) : [];
          // Timeline
          this.updateTimelineData(this.$store.state.activeConsultationInfo.patient);
      }
      return this.$store.state.activeConsultationInfo
    },
    currentMedsList () {
      this.buildEmptyArr(this.$store.state.medications);
      return this.$store.state.medications;
    },
    currentPrescriptionInfo() {
      return this.$store.state.activePrescriptionInfo;
    },
    currentExamInfo() {
      return this.$store.state.activeExamInfo;
    },
    allPatientEvents() {
      if(this.$store.state.events) {
        const patientId = this.activeConsultationInfo.patient.id;
        const data = this.$store.state.events.filter(event => event.patient_id === patientId);
        this.fillRecordFields(data);
        return data;
      }
      return [];
    }
  },
  methods: {
    scroll(){
       window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    goBack(){
      window.location.href = '/consultations/history';
    },
    fillRecordFields(patientEvents) {
      if(Array.isArray(patientEvents) && patientEvents.length) {
        this.examsList = [];
        this.prescriptionsList = [];
        for (const patientEvent of patientEvents) {
          if(patientEvent.meta && patientEvent.meta.exam_id) {
            const examInfo =  { exam_id: patientEvent.meta.exam_id };
            examInfo.date = moment(patientEvent.date).format('DD/MM/YYYY');
            this.examsList.push(examInfo);
          }
          if(patientEvent.meta && patientEvent.meta.prescription_id) {
            const prescriptionInfo =  { prescription_id: patientEvent.meta.prescription_id };
            prescriptionInfo.date = moment(patientEvent.date).format('DD/MM/YYYY');
            this.prescriptionsList.push(prescriptionInfo);
          }
        }
        this.examsList = this.examsList.sort((a,b) => - new moment(a.date).format('YYYYMMDD') + new moment(b.date).format('YYYYMMDD'));
        this.prescriptionsList = this.prescriptionsList.sort((a,b) =>  - new moment(a.date).format('YYYYMMDD') + new moment(b.date).format('YYYYMMDD'));
        if(this.examsList.length > 2) {
          this.examsList = this.examsList.splice(0,3);
        }
        if(this.prescriptionsList.length > 2) {
          this.prescriptionsList = this.prescriptionsList.splice(0,3);
        }
      }
    },
    editConsultation() {
      this.isReadOnly = !this.isReadOnly;
    },
    showCancelConsultationModal() {
      this.$modal.show('cancelConsultationModal');
    },
    closeCancelConsultationModal() {
      this.$modal.hide('cancelConsultationModal')
    },
    cancelConsultation() {
      var payload = new Object();
      payload.event_id = this.$route.query.consultationId;
      payload.meta = {...this.activeConsultationInfo.meta, ...{...this.consultationDetail, ...{status: 'Anulada'}}};
      
      var notifPayload = new Object();
      notifPayload.patient_first_name = this.activeConsultationInfo.patient.first_name;
      notifPayload.patient_last_name = this.activeConsultationInfo.patient.last_name;
      notifPayload.doctor_first_name = this.activeConsultationInfo.doctor.first_name;
      notifPayload.doctor_last_name = this.activeConsultationInfo.doctor.last_name;
      notifPayload.doctor_email = this.activeConsultationInfo.doctor.email;
      notifPayload.event_date = this.activeConsultationInfo.date;
      notifPayload.id = this.activeConsultationInfo.id;
      notifPayload.patient_email = this.activeConsultationInfo.patient.email;
      notifPayload.patient_phone = this.activeConsultationInfo.patient.phone;
      notifPayload.patient_id = this.activeConsultationInfo.patient.id;
      notifPayload.clinic_title = this.activeConsultationInfo.clinic.title;
      notifPayload.clinic_address = this.activeConsultationInfo.clinic.address;
      notifPayload.clinic_phone = this.activeConsultationInfo.clinic.phone[0] ? this.activeConsultationInfo.clinic.phone[0] : '';
      notifPayload.clinic_address_2 = this.activeConsultationInfo.clinic.address_2 ? this.activeConsultationInfo.clinic.address_2  : '';
      notifPayload.clinic_city = this.activeConsultationInfo.clinic.city ? this.activeConsultationInfo.clinic.city : '';
      notifPayload.clinic_country = this.activeConsultationInfo.clinic.country ? this.activeConsultationInfo.clinic.country : '';

      this.$store.dispatch('editEvent',payload).then(response => {
        
        // console.log(response);
        this.showAlert('success','Consulta anulada','Consulta anulada éxitosamente!');
        
        this.$store.dispatch('notifyAnnulation', notifPayload).then((response) => { 
          setTimeout(() => {
            window.location.href = '/consultations/history';
          }, 1500);         
        }).catch(function (error) {
            console.log(error);
        });

      }, error => {
        console.error(error);
        this.showAlert('danger','Error al anular consulta',error.response.data.error);

      });
    },
    finishConsultation(){
      var payload = new Object();
      payload.event_id = this.$route.query.consultationId;
      // console.log(this.consultationTotal);
      payload.meta = {...this.activeConsultationInfo.meta, ...{...this.consultationDetail, ...{status: 'Terminada'}}};
      this.$store.dispatch('editEvent',payload).then(response => {
        
        // console.log('RESPONSE!: ',response);
        this.showAlert('success','Consulta Actualizada','Signos Vitales Actualizados Correctamente!');
        response.data.data.event.instructions = this.prescriptionDetail.instructions
        console.log(response)
        setTimeout(() => {
            window.location.href = '/consultations/upcommingAppointments';
          }, 1500);
        
      }, error => {
        console.error(error);
        this.showAlert('danger','Error al terminar consulta',error.response.data.error);

      });
    },
    buildEmptyArr(list){
      var emptyArr = [];
      list.forEach((element,index,array) => {
        let emptyObj = new Object();
        emptyObj.id = element.id,
        emptyObj.dose_unit = null,
        emptyObj.dose_value = null,
        emptyObj.freq_unit = null,
        emptyObj.freq_value = null,
        emptyObj.dur_unit = null,
        emptyObj.dur_value = null,
        emptyObj.instructions = null;
        emptyArr[element.id] = emptyObj;
        if(index == array.length-1){
          this.prescriptionMeds = emptyArr;
          // console.log(this.prescriptionMeds)
        }    
      });
    },
    calculateAge(dob){
        var birth_year = dob.substring(0,4),
        birth_month = dob.substring(5,7),
        birth_day = dob.substring(8,10);
        
        var today_date = new Date(),
        today_year = today_date.getFullYear(),
        today_month = today_date.getMonth(),
        today_day = today_date.getDate(),
        age = today_year - birth_year;

        if ( today_month < (birth_month - 1))
        {
            age--;
        }
        if (((birth_month - 1) == today_month) && (today_day < birth_day))
        {
            age--;
        }
        return age;
    },
    goZM(){
      window.open('https://us05web.zoom.us/j/82145287043?pwd=K1V1d28xL1dtNVA5MHMrWVNpMzJkZz09', '_blank');
    },
    goTobox() {
      window.open('/dashboard/d', '_self')
    },
    openExamDetailModal(){
      this.activePromptExams = true;
    },
    saveRecipeDetail (){
      // console.log(this.prescriptionDetail);
      // console.log(this.prescriptionMeds);
      // building prescriptionObject payload
      var prescriptionObj = new Object();
      prescriptionObj.event_id = this.$route.query.consultationId;
      prescriptionObj.patient_id = this.activeConsultationInfo.patient_id,
      prescriptionObj.meta = {},
      prescriptionObj.meta.instructions = this.prescriptionDetail.instructions,
      prescriptionObj.medications = [];
      //console.log(this.prescriptionDetail.medications.length);
      if(this.prescriptionDetail.medications.length == 0 && this.prescriptionDetail.instructions){
        if(this.hasActivePrescription && this.currentPrescriptionInfo){
          prescriptionObj.medications[0] = {};
          prescriptionObj.prescription_id = this.currentPrescriptionInfo.id;
          this.$store.dispatch('editPrescription',prescriptionObj).then(response => {
            this.showAlert('success','Receta guardada','Receta guardada éxitosamente!');
            // must clean
          }, error => {
            console.error(error);
            this.showAlert('danger','Error al guardar Receta',error.response.data.error);
          });
        } else {
          this.$store.dispatch('addPrescription',prescriptionObj).then(response => {
            // console.log(response);
            // add prescription id to consultation meta
            this.addPrescriptionId(response.data.data.prescription.id);
            this.showAlert('success','Receta guardada','Receta guardada éxitosamente!');
            this.getPrescription(response.data.data.prescription.id);
            // must clean
            
          }, error => {
            console.error(error);
            this.showAlert('danger','Error al guardar Receta',error.response.data.error);
          });
        }
      } else {
        this.prescriptionDetail.medications.forEach((element, index, array) => {
          prescriptionObj.medications[index] = {},
          prescriptionObj.medications[index].frequency = this.prescriptionMeds[element.id].freq_unit+' | '+this.prescriptionMeds[element.id].freq_value ,
          prescriptionObj.medications[index].dose = this.prescriptionMeds[element.id].dose_unit+' | '+this.prescriptionMeds[element.id].dose_value,
          prescriptionObj.medications[index].instructions = (this.prescriptionMeds[element.id].instructions ? this.prescriptionMeds[element.id].instructions :'')+
            ' | Durante:  | '+
            this.prescriptionMeds[element.id].dur_unit+'  |  '+
            this.prescriptionMeds[element.id].dur_value,
            prescriptionObj.medications[index].medication_id = element.id;

            // si ya termino:
            if(index == array.length-1){
              if(this.hasActivePrescription && this.currentPrescriptionInfo){

                prescriptionObj.prescription_id = this.currentPrescriptionInfo.id;
                this.$store.dispatch('editPrescription',prescriptionObj).then(response => {
                  this.showAlert('success','Receta guardada','Receta guardada éxitosamente!');
                  // must clean
                }, error => {
                  console.error(error);
                  this.showAlert('danger','Error al guardar Receta',error.response.data.error);
                });
              } else {
                this.$store.dispatch('addPrescription',prescriptionObj).then(response => {
                  // console.log(response);
                  // add prescription id to consultation meta
                  this.addPrescriptionId(response.data.data.prescription.id);
                  this.showAlert('success','Receta guardada','Receta guardada éxitosamente!');
                  this.getPrescription(response.data.data.prescription.id);
                  // must clean
                  
                }, error => {
                  console.error(error);
                  this.showAlert('danger','Error al guardar Receta',error.response.data.error);
                });
              }

            }
        });
      }
      
      this.activePromptRecipe = false;
    },
    addPrescriptionId(id){
      var payload = new Object();
      payload.event_id = this.$route.query.consultationId;
      payload.meta = {...this.activeConsultationInfo.meta, ...{...this.consultationDetail, ...{prescription_id: id}}};
      this.$store.dispatch('editEvent',payload).then(response => {
        
        this.$store.dispatch('getConsultationById', this.$route.query.consultationId).then(response => { 
        }, error => {
            console.error(error);
        }); 
        
        // console.log(response);
        this.showAlert('success','Consulta actualizada','Consulta actualizada éxitosamente!');

      }, error => {
        console.error(error);
        this.showAlert('danger','Error al actualizar consulta',error.response.data.error);

      });
    },
    getPrescription(id){
      this.$store.dispatch('getPrescriptionById', id).then(response => {
          
          if(response.data.data.prescription){
            // console.log('hay receta');
            this.hasActivePrescription = true;
            // console.log(response.data.data.prescription);
            this.prescriptionDetail.instructions = response.data.data.prescription.meta.instructions ? response.data.data.prescription.meta.instructions : '';
            if(response.data.data.prescription.medications){
              response.data.data.prescription.medications.forEach((element,index,array) => {

                // console.log(this.prescriptionMeds);

                let curMed = this.currentMedsList.filter(obj => {
                  return obj.id === element.medication_id                  
                });

                this.prescriptionDetail.medications[index] = curMed[0];

                this.prescriptionMeds[element.medication_id].dose_unit = element.dose.split("|")[0].replaceAll(' ', ''),
                this.prescriptionMeds[element.medication_id].dose_value = element.dose.split("|")[1].replaceAll(' ', ''),
                this.prescriptionMeds[element.medication_id].dur_unit = element.instructions.split("|")[2].replaceAll(' ', ''),
                this.prescriptionMeds[element.medication_id].dur_value = element.instructions.split("|")[3].replaceAll(' ', ''),
                this.prescriptionMeds[element.medication_id].freq_unit = element.frequency.split("|")[0].replaceAll(' ', ''),
                this.prescriptionMeds[element.medication_id].freq_value = element.frequency.split("|")[1].replaceAll(' ', ''),
                this.prescriptionMeds[element.medication_id].instructions = element.instructions.split("|")[0];
                
                this.forceRecipeUpdate +=1;
              });
            } 

          }
          this.loading = false;
      }, error => {
          console.error(error);
      }); 
    },
    getExam(id){
      this.$store.dispatch('getExamById', id).then(response => {
          // console.log(response);
          if(response.data.data.exam){
            // console.log('hay examen');
            this.hasActiveExam = true;
            // console.log(response.data.data.exam);
            this.examDetail.instructions = response.data.data.exam.recommendations ? response.data.data.exam.recommendations : '';
            if(response.data.data.exam.meta && response.data.data.exam.meta.exams){
              response.data.data.exam.meta.exams.forEach((element,index,array) => {
                this.examDetail.exams[index] = {};
                if(element){
                  // console.log(element);
                  this.examDetail.exams[index].instructions = element.instructions,
                  this.examDetail.exams[index].name = element.name,
                  this.examDetail.exams[index].type = element.type;
                }

                this.forceExamUpdate +=1;
              });
            } 

          }
          this.loading = false;
      }, error => {
          console.error(error);
      }); 
    },
    saveExamDetail (){
      // console.log(this.examDetail);
      var examObj = new Object();
      examObj.patient_id = this.activeConsultationInfo.patient_id,
      examObj.meta = {},
      examObj.type = 'Solicitud de examen',
      examObj.event_id = this.$route.query.consultationId,
      examObj.recommendations = this.examDetail.instructions,
      examObj.meta.exams = [];
      if(this.examDetail.exams.length == 0 && this.examDetail.instructions){
        if(this.hasActiveExam && this.currentExamInfo){
          examObj.meta.exams[0] = {};
          examObj.exam_id = this.currentExamInfo.id;
          this.$store.dispatch('editExam',examObj).then(response => {
            // console.log(response);
            this.showAlert('success','Solicitud de Examen guardada','Examen guardada éxitosamente!');
            // must clean
          }, error => {
            console.error(error);
            this.showAlert('danger','Error al guardar Examen',error.response.data.error);
          });
        } else {
          this.$store.dispatch('addExam',examObj).then(response => {
              // console.log(response);
              
              this.addExamId(response.data.data.exam.id);
              this.getExam(response.data.data.exam.id);
              this.showAlert('success','Solicitud de Examen guardada','Solicitud de Examen guardada éxitosamente!');
              // must clean
              
            }, error => {
              console.error(error);
              this.showAlert('danger','Error al guardar Solicitud de Examen',error.response.data.error);
            });
        }
      } else {
        this.examDetail.exams.forEach((element, index, array) => {
          examObj.meta.exams[index] = {};
          
          examObj.meta.exams[index].instructions = element.instructions,
          examObj.meta.exams[index].name = element.name,
          examObj.meta.exams[index].type = element.type;
            // si ya termino:
            if(index == array.length-1){
              if(this.hasActiveExam && this.currentExamInfo){
                examObj.exam_id = this.currentExamInfo.id;
                this.$store.dispatch('editExam',examObj).then(response => {
                  this.showAlert('success','Solicitud de Examen guardada','Solicitud de Examen guardada éxitosamente!');
                  // must clean
                }, error => {
                  console.error(error);
                  this.showAlert('danger','Error al guardar Solicitud de Examen',error.response.data.error);
                });
              } else {
                this.$store.dispatch('addExam',examObj).then(response => {
                // console.log(response);
                // add exam_id to consultation meta
                this.addExamId(response.data.data.exam.id);
                this.showAlert('success','Solicitud de Examen guardada','Solicitud de Examen guardada éxitosamente!');
                this.getExam(response.data.data.exam.id);

                // must clean
                
              }, error => {
                console.error(error);
                this.showAlert('danger','Error al guardar Solicitud de Examen',error.response.data.error);
              });
              }
              
            }
        });
      }
      
      this.activePromptExams = false;
    },
    addExamId(id){
      var payload = new Object();
      payload.event_id = this.$route.query.consultationId;
      payload.meta = {...this.activeConsultationInfo.meta, ...{...this.consultationDetail,...{exam_id: id}}};
      
      this.$store.dispatch('editEvent',payload).then(response => {
        // console.log(response);
        this.showAlert('success','Consulta actualizada','Consulta actualizada éxitosamente!');
        
        this.$store.dispatch('getConsultationById', this.$route.query.consultationId).then(response => { 
        }, error => {
            console.error(error);
        }); 

      }, error => {
        console.error(error);
        this.showAlert('danger','Error al actualizar consulta',error.response.data.error);

      });
    },
    openRecipeDetailModal(){
      this.activePromptRecipe = true;
    },

    customLabel (obj) {
      return `${obj.name} ${obj.component ? ' - Componente: '+obj.component+' - ' : '' } ${obj.category ? 'Categoría: '+obj.category : ''}`
    },
    addMed(){
      var med = new Object();
      med.id = 1;
      med.name = this.currentDrug;
      med.desc = 'Descripción '.concat(this.currentDrug);
      med.lab = 'Laboratorio '.concat(this.currentDrug);
      med.mol = 'Molecula '.concat(this.currentDrug);
      this.consultationDetail.meds.push(med);
    },
    openPatientView(){
      window.open('/patients/patient/view/' + this.activeConsultationInfo.patient.id, '_blank')
    },
    openRecipeView(id){
      window.open('/recipes/recipe/view/'+id, '_blank')
    },
    openExamView(id){
      window.open('/recipes/exam/view/'+id, '_blank')
    },
    CandD ({ c, d }) {
      return `${c} : ${d}`
    },
    removeVitalSign(i){
      if (i !== -1) {
        this.consultationDetail.vitalSigns.splice(i, 1);
      }
    },
    removeDiseases(i){
      if (i !== -1) {
        this.consultationDetail.diseases.splice(i, 1);
      }
    },
    removeUsedMeds(i){
      if (i !== -1) {
        this.consultationDetail.usedMeds.splice(i, 1);
      }
    },
    formSubmitted () {
      // save Recipe and Exam if changes were not saved
      this.saveRecipeDetail();
      this.saveExamDetail();

      // console.log(this.consultationDetail);
      // add consultation details to event

      // creating custom questions:
      var customQuestions = new Array();
      for (let index = 0; index < this.userQuestions.length; index++) {
        let tempObj = new Object();
        tempObj.name = this.userQuestions[index].name;
        tempObj.title = this.userQuestions[index].title;
        tempObj.instructions = this.userQuestions[index].placeholder;
        tempObj.active = this.userQuestions[index].active;
        tempObj.answer = this.customQuestionsAnswers[index];
        customQuestions.push(tempObj);
      }
      var payload = new Object();
      payload.event_id = this.$route.query.consultationId;
      payload.meta = {...this.activeConsultationInfo.meta, ...this.consultationDetail, ...{status: 'Signos Vitales'}, ...{'customQuestions': customQuestions}};
      // console.log('meta: ',payload.meta);
      this.$store.dispatch('editEvent',payload).then(response => {
        // console.log(response);
        
        this.showAlert('success','Consulta guardada','Signos vitales actualizados éxitosamente!');
        this.$watch.allPatientEvents();
        
        // this.consultationDetail = this.consultationDetailDef;
        
      }, error => {
        console.error(error);
        this.showAlert('danger','Error al editar consulta',error.response.data.error);
      });

      // console.log(this.prescriptionDetail);
      // console.log(this.prescriptionMeds);
      // console.log(this.examDetail);
      //this.$modal.show('formSubmittedModal');
      setTimeout(() => {
            window.location.href = '/consultations/upcommingAppointments';
          }, 1500);
    },
    showRecordModal(){
      this.$modal.show('recordModal');
    },
    generateData ({ header, results, meta }) {
      this.excelData.header = header
      this.excelData.results = results
      this.excelData.meta = meta
      if (this.onSuccess) this.onSuccess(this.excelData)
    },
    getHeaderRow (sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C = undefined
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = `UNKNOWN ${  C}` // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    // 
    firebaseUpload(file){

      var fileURL = null, uploadValue = null, fileName = null;

      const storageRef = firebase.storage().ref(file.name).put(file);
      storageRef.on(`state_changed`,snapshot=>{
        uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, error=>{
         this.showAlert('danger','Error al agregar documentos a consulta',error.message);
          console.log(error.message)
        },
      () => {

          uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url)=>{
            fileURL = url;
            fileName = file.name;
            this.documentsList.push({'fileName' : fileName, 'fileURL': fileURL});
            var payload = new Object();
            payload.event_id = this.$route.query.consultationId;
            payload.meta = {...this.activeConsultationInfo.meta, ...{...this.consultationDetail, ...{documentsList: this.documentsList }}};
            this.$store.dispatch('editEvent',payload).then(response => {
              

              // console.log(response);
              this.showAlert('success','Documento Agregado','Consulta actualizada éxitosamente!');

            }, error => {
              console.error(error);
              this.showAlert('danger','Error al agregar documentos a consulta',error.response.data.error);

            });

          }
        );
      });
    },
    handleDragover (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop (e) {
      console.log('handle drop')
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      console.log(files)
      files.forEach(file => this.firebaseUpload(file));
      
      // this.uploadFile(rawFile)
    },
    readerData (rawFile) {
      console.log(rawFile);
      return;
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = XLSX.utils.sheet_to_json(worksheet)
          const meta = { sheetName: firstSheetName }
          this.generateData({ header, results, meta })
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    handleClick (e) {
      
      console.log('handle drop')
      e.stopPropagation()
      e.preventDefault()
      const files = e.target.files
      console.log(files)
      files.forEach(file => this.firebaseUpload(file));
    },
    isExcel (file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    uploadFile (file) {
      this.$refs['fileInput'].value = null // fix can't select the same excel
      this.readerData(file)
    },
    // ------  SHOW ALERT ------
    // ------------------------- 
    showAlert (color,title,text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text
      })
    },
    updateTimelineData(patient) {
      if(patient) {
        const { meta } = patient;
        if (meta) {
          const timelineData = [];
          // TODO list meta items.
          const baseObject = {
            color: "dark",
            icon: "ChevronsRightIcon",
            title: "No hay Registros",
            desc: "Paciente Nuevo",
            // time  : 'Hoy'
          };
          const personalInformation = ['height', 'weight', 'blood_type'];
          // Personal Information
          const heightObject = Object.assign({}, baseObject);
          heightObject.title = "Estatura";
          heightObject.desc = meta['height'] ? meta['height'] + " Metros": 'No Disponible';
          timelineData.push(heightObject);

          const weightObject = Object.assign({}, baseObject);
          weightObject.title = "Peso";
          weightObject.desc = meta['weight'] ? meta['weight'] + " Libras" : 'No Disponible';
          timelineData.push(weightObject);

          const bloodObject = Object.assign({}, baseObject);
          bloodObject.title = "Grupo sanguíneo";
          bloodObject.desc = meta['blood_type'] ? meta['blood_type'] : 'No Disponible';
          timelineData.push(bloodObject);

          const allergyObject = Object.assign({}, baseObject);
          allergyObject.title = "Alergías";
          allergyObject.desc = meta['allergyBool'] ? 'Si' : 'No';
          allergyObject.detailedDesc = meta['allergyBool'] ? meta['allergyVal'] : '';
          timelineData.push(allergyObject);

          const conditionObject = Object.assign({}, baseObject);
          conditionObject.title = "Enfermedades";
          conditionObject.desc = meta['conditionBool'] ? 'Si' : 'No';
          conditionObject.detailedDesc = meta['conditionVal'] ? meta['conditionVal'] : '';
          timelineData.push(conditionObject);

          const medsObject = Object.assign({}, baseObject);
          medsObject.title = "¿Utiliza medicamentos?";
          medsObject.desc = meta['MedsBool'] ? 'Si' : 'No';
          medsObject.detailedDesc = meta['MedsVal'] ? meta['MedsVal'] : '';
          timelineData.push(medsObject);

          const cancerObject = Object.assign({}, baseObject);
          cancerObject.title = "Antecedentes de Cáncer en la familia";
          cancerObject.desc = meta['cancerBool'] ? 'Si' : 'No';
          cancerObject.detailedDesc = meta['cancerVal'] ? meta['cancerVal'] : '';
          timelineData.push(cancerObject);

          const exerciseObject = Object.assign({}, baseObject);
          exerciseObject.title = "¿Hace Ejercicio?";
          exerciseObject.desc = meta['exercise'] ? 'Si' : 'No';
          exerciseObject.detailedDesc = meta['exercise'] ? 
            {
              exercise: {
              exerciseType: meta['exerciseType'],
              exerciseFreq: meta['exerciseFreq'],
              exerciseTime: meta['exerciseTime'],
              }
            }
            : '';
          timelineData.push(exerciseObject);

          const smokeObject = Object.assign({}, baseObject);
          smokeObject.title = "¿Fuma?";
          smokeObject.desc = meta['smoke'] ? 'Si' : 'No';
          smokeObject.detailedDesc = meta['smokeDetail'] ? meta['smokeDetail'] : '';
          timelineData.push(smokeObject);

          const surgeryObject = Object.assign({}, baseObject);
          surgeryObject.title = "Antecedentes de Cirugías";
          surgeryObject.desc = meta['surgeryBool'] ? 'Si' : 'No';
          surgeryObject.detailedDesc = meta['surgeryVal'] ? meta['surgeryVal'] : '';
          timelineData.push(surgeryObject);

          this.timelineData = timelineData;
        } else {
          this.timelineData = this.timelineDataDefault;
        }
      }
    }
  },
  beforeCreate () {
    // console.log(this.$route.query.consultationId);
    this.$store.dispatch('getConsultationById', this.$route.query.consultationId).then(response => {
          
          this.$store.dispatch('fetchEvents');

          console.log(response.data);
          if(response.data.data.event.meta && response.data.data.event.meta.prescription_id ){
            this.getPrescription(response.data.data.event.meta.prescription_id);
          }
          if(response.data.data.event.meta && response.data.data.event.meta.exam_id ){
            this.getExam(response.data.data.event.meta.exam_id);
          }
          if(response.data.data.event.meta && response.data.data.event.meta.customQuestions){
            this.userQuestions = JSON.parse(JSON.stringify(response.data.data.event.meta.customQuestions));
            this.customQuestionsAnswers = new Array(this.userQuestions.length);
            for (let index = 0; index < this.userQuestions.length; index++) {
              this.customQuestionsAnswers[index] = this.userQuestions[index].answer;
            }
          } else {
            // obteniendo preguntas dinámicas
            if(this.$store.state.AppActiveUser.meta.consultation_questions){
              this.userQuestions = JSON.parse(JSON.stringify(this.$store.state.AppActiveUser.meta.consultation_questions))
              this.customQuestionsAnswers = new Array(this.userQuestions.length);
            }
            console.log('preguntas: ',this.userQuestions);
          }
          if(response.data.data.event.meta && response.data.data.event.meta.consultationTotal){
            this.consultationDetail.consultationTotal = response.data.data.event.meta.consultationTotal;
          } else if ( !this.isSecretary && this.$store.state.AppActiveUser.meta && this.$store.state.AppActiveUser.meta.defaultPrice ) {
            this.consultationDetail.consultationTotal =  this.$store.state.AppActiveUser.meta.defaultPrice;
          } else if ( this.isSecretary && this.activeDoctorData.meta && this.activeDoctorData.meta.defaultPrice ){
            this.consultationDetail.consultationTotal = this.activeDoctorData.meta.defaultPrice;
          } else {
            this.consultationDetail.consultationTotal = 250.00;
          }
          this.loading = false;
      }, error => {
          console.error(error);
      }); 
  },
  created () {

    

    // Browser Analytics
    this.activeConsultationInfo;
    // this.$http.get('/api/card/card-statistics/subscribers')
    //   .then((response) => { this.subscribersGained = response.data; console.log(response.data) })
    //   .catch((error) => { console.log(error) });
    this.cieArray = cieArray;

    // fetching current medications list
    this.$store.dispatch('fetchMedications');
  },
  beforeMount() {
    if(this.activeUserInfo.role == "secretaria" ){
      // console.log('Es SECRE');
        this.isSecretary = true;
        this.$store.dispatch('getDoctorDataById', sessionStorage.getItem('activeDoctorId')).then(response=>{
          // console.log('DOCTOR: ',response);
          this.activeDoctorData = JSON.parse(JSON.stringify(response.data.data.user));
        }, error => {
          console.error(error);
        });
      } else {
        this.isSecretary = false;
      }
  },
  mounted () {
    // this.cieArray = cieArray;
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true);
    bus.$on('toggleTimelineModal', (data) => {
      // console.log(data);
      this.timelineRecord = data;
      this.$modal.show('recordModal');
      
    })
  },
  components: {
    FormWizard,
    TabContent,
    vSelect,
    VxTimeline,
    Multiselect,
    StatisticsCardLine,
    VueApexCharts
  },
  watch: {
    'consultationDetail.vitalSigns': function(val){
      // console.log(val);
    },
    allPatientEvents: function(data) {
      data = data.slice(-5);
      // Bloque de datos
      // Presion arterial
      const presionArterial = [];
      const presionArterialData = [{
              name: "Sistólica",
              data: []
          },
          {
              name: "Diastólica",
              data: []
          }
      ];
      const presionArterialCategories = [];
      // Niveles de Azúcar
      const nivelAzucar = [];
      const nivelAzucarData = [{
              name: "Nivel de Azúcar",
              data: []
          }
      ];
      const nivelAzucarCategories = [];
      // Nivel de Oxigeno
      const nivelOxigeno = [];
      const nivelOxigenoData = [{
              name: "Saturación de oxigeno",
              data: []
          }
      ];
      const nivelOxigenoCategories = [];
      // Pulso
      const pulso = [];
      const pulsoData = [{
              name: "Pulso",
              data: []
          }
      ];
      const pulsoCategories = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        presionArterialCategories.push(`# ${element.id}`);
        if(element.meta && Array.isArray(element.meta.vitalSigns)) {
          for (let indexMeta = 0; indexMeta < element.meta.vitalSigns.length; indexMeta++) {
            const vitalSign = element.meta.vitalSigns[indexMeta];
            switch (vitalSign.id) {
              case 1:
                presionArterial.push(vitalSign.options);
                break;
              case 2:
                  nivelAzucar.push(vitalSign.options);
                break;
              case 3:
                  nivelOxigeno.push(vitalSign.options);
                break;
              case 4:
                  pulso.push(vitalSign.options);
                break;
              default:
                break;
            }
          }
        }
      }
      // Presion arterial
      if (presionArterial.length) {
        for (let index = 0; index < presionArterial.length; index++) {
          const element = presionArterial[index];
          if(element[0] && element[0].name === 'Presión Sistólica') {
            presionArterialData[0].data.push(element[0].value);
          }
          if(element[1] && element[1].name === 'Presión Diastólica') {
            presionArterialData[1].data.push(element[1].value);
          }
        }
        // console.log(presionArterialData);
        // Data
        this.analyticsData.bloodPressure.tempSeries = [
          ... presionArterialData
        ];
        // Categories
        this.analyticsData.bloodPressure.chartOptions = { 
          ...this.analyticsData.bloodPressure.chartOptions,
          ...{
                xaxis: {
                    categories: presionArterialCategories
                }
            }
        };
      }
      // Nivel de Oxigeno
      if (nivelOxigeno.length) {
        for (let index = 0; index < nivelOxigeno.length; index++) {
          const element = nivelOxigeno[index];
          const dataValue = element.find(item => item.id === 2);
          if(dataValue) {
            nivelOxigenoData[0].data.push(dataValue.value);
          }
        }
        // Data
        this.analyticsData.bloodOx.tempSeries = [
          ... nivelOxigenoData
        ];
        // Categories
        this.analyticsData.bloodOx.chartOptions = { 
          ...this.analyticsData.bloodOx.chartOptions,
          ...{
                xaxis: {
                    categories: presionArterialCategories
                }
            }
        };
      }
      // Nivel de Azúcar
      if (nivelAzucar.length) {
        for (let index = 0; index < nivelAzucar.length; index++) {
          const element = nivelAzucar[index];
          const dataValue = element.find(item => item.id === 2);
          if(dataValue) {
            nivelAzucarData[0].data.push(dataValue.unit === 'mg/dL' 
              ? dataValue.value : (Number(dataValue.value)*18.018));
          }
        }
        // Data
        this.analyticsData.bloodSugar.tempSeries = [
          ... nivelAzucarData
        ];
        // Categories
        this.analyticsData.bloodSugar.chartOptions = { 
          ...this.analyticsData.bloodSugar.chartOptions,
          ...{
                xaxis: {
                    categories: presionArterialCategories
                }
            }
        };
      }
      // Pulso
      if (pulso.length) {
        for (let index = 0; index < pulso.length; index++) {
          const element = pulso[index];
          const dataValue = element.find(item => item.id === 2);
          if(dataValue) {
            pulsoData[0].data.push(dataValue.value);
          }
        }
        // Data
        this.analyticsData.bloodPulse.tempSeries = [
          ... pulsoData
        ];
        // Categories
        this.analyticsData.bloodPulse.chartOptions = { 
          ...this.analyticsData.bloodPulse.chartOptions,
          ...{
                xaxis: {
                    categories: presionArterialCategories
                }
            }
        };
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
span.vs__selected {
    background-color: #0033a1 !important;
}
.zoom:hover {
  transform: scale(1.2); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
.zoom {
  transition: transform .3s; /* Animation */
}

</style>